import { isThemeChoice, RANDOM_THEME, THEME_IDS, type ThemeChoice } from "../src/themes";
import { h } from "./dom";
import { LANG } from "./i18n";
import { STRINGS } from "./strings";

/** Theme ids sorted by their name in the current UI language. */
const SORTED_THEMES = [...THEME_IDS].sort((a, b) => STRINGS.themes[a].localeCompare(STRINGS.themes[b], LANG));

/** <select> with "random" first, then every theme in alphabetical order. */
export function themeSelect(id: string, value: ThemeChoice = RANDOM_THEME): HTMLSelectElement {
  const select = h(
    "select",
    { id, name: "theme", class: "select" },
    h("option", { value: RANDOM_THEME }, STRINGS.themeRandom),
    ...SORTED_THEMES.map((theme) => h("option", { value: theme }, STRINGS.themes[theme])),
  );
  select.value = value;
  return select;
}

export function selectedTheme(select: HTMLSelectElement): ThemeChoice {
  return isThemeChoice(select.value) ? select.value : RANDOM_THEME;
}
